import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  Box,
  CircularProgress,
  Divider,
  Paper,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import axios from "axios";
const popInAnimation = {
  "@keyframes popIn": {
    "0%": { transform: "scale(0.5)", opacity: 0 },
    "100%": { transform: "scale(1)", opacity: 1 },
  },
};



const shuffleArray = (array) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

const shuffleQuiz = (questionsArray) => {
  const shuffledQuestions = shuffleArray(questionsArray);
  return shuffledQuestions.map((question) => ({
    ...question,
    answerOptions: shuffleArray(question.respuestas),
  }));
};

const INITIAL_TIME = 1800;
const SESSION_KEY = "quizSession";

function QuizForm() {
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);
  const [answers, setAnswers] = useState({});
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const timerRef = useRef(null);
  const nav = useNavigate();
const [poolDePreguntas, setPoolDePreguntas] = useState([]); // 'savedExams' ya existe en tu código, solo nos aseguraremos de que se inicialice vacío. 
  const [loading, setLoading] = useState(true);
  const [items, setItems] = React.useState([]);
  const [selectedSavedExam, setSelectedSavedExam] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("prop");
  const proyect = JSON.parse(token);
   const [currentIntentId, setCurrentIntentId] = useState();
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
    console.log(token,items)
  }, []);
  const obtenerIntentosDeExamen = async () => {
    setLoading(true);
    //setError(null);
    try {
        // CAMBIO: Carga completa con preguntas y respuestas
        const { data } = await axios.get(`/detalleExamen/${token}`);
        
        // Opcional: normalizar estructura si tu UI espera formato específico
        setSelectedSavedExam(data);
        setTimeLeft((data.tiempo_limite_minutos*60))
        console.log(data,"datos Examen");
        //setOpenDetailsModal(true);
      } catch (error) {
        console.error("Error cargando detalles:", error);
        //showSnackbar("No se pudieron cargar los detalles del examen.", "error");
      }
  };
  useEffect(() => {
    obtenerIntentosDeExamen();
  }, []); // El array vacío [] asegura que se ejecute solo una vez al inicio
  useEffect(() => {
  if (!selectedSavedExam) return;

  console.log("selectedSavedExam seteado:", selectedSavedExam);
    try {
      const savedSession = sessionStorage.getItem(SESSION_KEY);
      if (savedSession) {
        const sessionData = JSON.parse(savedSession);
        setShuffledQuestions(sessionData.questions);
        setAnswers(sessionData.answers);

        const timeRemaining = Math.round(
          (sessionData.deadline - Date.now()) / 1000
        );
        setTimeLeft(timeRemaining > 0 ? timeRemaining : 0);
      } else {
        const newQuestions = shuffleQuiz(selectedSavedExam.preguntas);
        const newDeadline = Date.now() + timeLeft * 1000;
        const newSession = {
          questions: newQuestions,
          answers: {},
          deadline: newDeadline,
        };
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSession));
        setShuffledQuestions(newQuestions);
       // setTimeLeft(INITIAL_TIME);
      }
    } catch (error) {
      console.error("Error processing session storage:", error);
      sessionStorage.removeItem(SESSION_KEY);
      window.location.reload();
    }
    setIsLoaded(true);
  }, [selectedSavedExam]);

  useEffect(() => {
    if (!isLoaded) return;

    try {
      const savedSession = sessionStorage.getItem(SESSION_KEY);
      if (savedSession) {
        const sessionData = JSON.parse(savedSession);
        sessionData.answers = answers;
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
      }
    } catch (error) {
      console.error("Error saving answers to session storage:", error);
    }
  }, [answers, isLoaded]);

//  const handleSubmit = useCallback(async () => {
//   // 1. Detener timer
//   if (timerRef.current) {
//     clearInterval(timerRef.current);
//   }

//   // 2. Calcular puntaje localmente
//   let newScore = 0;
//   shuffledQuestions.forEach((question, index) => {
//     // IMPORTANTE: Asegúrate de que 'answers' use IDs o Textos consistentemente.
//     // Si tu backend espera IDs de respuesta, ajusta aquí.
//     const correctAnswer = question.answerOptions.find(
//       (option) => option.es_correcta
//     );

//     // Comparación: Asumiendo que answers[index] guarda el texto o ID seleccionado
//     // Si answers guarda texto:
//     if (answers[index] === correctAnswer?.texto_respuesta) {
//        newScore++;
//     }
//     // O si answers guarda ID (RECOMENDADO para backend):
//     // if (answers[index] === correctAnswer?.id_respuesta) { newScore++; }
//   });

//   setScore(newScore);
  
//   // 3. Preparar datos para el backend
//   const tiempoUsado = INITIAL_TIME - timeLeft;
  
//   // Mapear respuestas al formato que espera el backend
//   // Si 'answers' es un objeto { indice_pregunta: valor }, conviértelo si hace falta
//   const respuestasEntregadas = {};
//   shuffledQuestions.forEach((q, idx) => {
//       // Guardamos { id_pregunta: respuesta_seleccionada }
//       respuestasEntregadas[q.id_pregunta] = answers[idx]; 
//   });

  

//   // 4. Llamar al endpoint
//   try {console.log("paso")
//     const response = await axios.post(
//       `/${selectedSavedExam.id_examen}/intentos/${items.id}/finalizar`,
//       {
//         id_usuario: items.id,
//         respuestas_entregadas: respuestasEntregadas,
//         puntaje_obtenido: newScore, // Tu variable local de puntaje
//         preguntas_para_aprobar: selectedSavedExam.preguntas_para_aprobar
//       }
//       // { headers: { Authorization: `Bearer ${token}` } } // Si no usas interceptor global
//     );

//     const { estado, puntaje_obtenido } = response.data;
    
//     // Feedback visual (opcional)
//     // showSnackbar(`Examen finalizado: ${estado}`, "success");

//   } catch (error) {
//     console.error("Error al guardar el intento:", error);
//     // showSnackbar("Error al guardar el resultado en el servidor", "error");
//     // Aun si falla el guardado, mostramos el score local al usuario
//   }

//   // 5. Finalizar UI
//   setShowScore(true);
//   sessionStorage.removeItem(SESSION_KEY);
//   window.scrollTo(0, 0);

// }, [answers, shuffledQuestions, timeLeft, selectedSavedExam,items.id]);

const handleSubmit = useCallback(async () => {
  if (timerRef.current) clearInterval(timerRef.current);

  let newScore = 0;
  shuffledQuestions.forEach((question, index) => {
    const correctAnswer = question.answerOptions.find(
      (option) => option.es_correcta
    );
    if (answers[index] === correctAnswer?.texto_respuesta) {
      newScore++;
    }
  });

  setScore(newScore);

  const respuestasEntregadas = {};
  shuffledQuestions.forEach((q, idx) => {
    respuestasEntregadas[q.id_pregunta] = answers[idx];
  });

  
  const userId = items.id;

  try {
    const response = await axios.post(
      `/${selectedSavedExam.id_examen}/intentos/${currentIntentId}/finalizar`,
      {
        id_usuario: userId,
        respuestas_entregadas: respuestasEntregadas,
        puntaje_obtenido: newScore,
        preguntas_para_aprobar: selectedSavedExam.preguntas_para_aprobar
      }
    );

    console.log("Resultado backend:", response.data);
  } catch (error) {
    console.error("Error al guardar el intento:", error);
  }

  setShowScore(true);
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(INTENTO_KEY);
  window.scrollTo(0, 0);
}, [answers, shuffledQuestions, selectedSavedExam, currentIntentId]);
  useEffect(() => {
    if (showScore || !isLoaded) return;

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [showScore, isLoaded]);

  useEffect(() => {
    if (timeLeft === 0 && isLoaded && !showScore) {
      handleSubmit();
    }
  }, [timeLeft, isLoaded, showScore, handleSubmit]);
/////////////////////////////////////////

var INTENTO_KEY;
useEffect(() => {
  
  if (!selectedSavedExam) return;
  const init = async () => {
    INTENTO_KEY = `exam_attempt_${selectedSavedExam.id_examen}`;
    const userId = items.id;
// 1) Ver si ya tengo un intento en esta sesión
    const savedAttempt = sessionStorage.getItem(INTENTO_KEY);
    if (savedAttempt) {
      const { id_intento } = JSON.parse(savedAttempt);
      setCurrentIntentId(id_intento);
      return;
    }
    const { data } = await axios.post(
      `/${selectedSavedExam.id_examen}/intentos`,
      { id_usuario: userId }
    );

    setCurrentIntentId(data.id_intento);
    sessionStorage.setItem(INTENTO_KEY, JSON.stringify({ id_intento: data.id_intento }));

  };

  init();
}, [selectedSavedExam]);

///////////////////////////////////
  const handleAnswerChange = (questionIndex, answer) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionIndex]: answer,
    }));
  };

  const handleRestartQuiz = () => {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(INTENTO_KEY);
    nav("/testUserDashboard")
  };

  const allQuestionsAnswered =
    shuffledQuestions.length > 0 &&
    shuffledQuestions.length === Object.keys(answers).length;

  if (!isLoaded) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  const isPassed = score >= selectedSavedExam.preguntas_para_aprobar
;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const displayTime = `${String(minutes).padStart(2, "0")}:${String(
    seconds
  ).padStart(2, "0")}`;

  return (
    // CAMBIO AQUÍ: Margen superior del contenedor principal aumentado
    <Container maxWidth="lg" sx={{ mt: 8, mb: 5 }}>
      {!showScore && (
        <Paper
          elevation={4}
          sx={{
            position: "fixed",
            top: { xs: 90, sm: 85 },
            right: { xs: 16, sm: 24 },
            p: "12px 24px",
            display: "flex",
            alignItems: "center",
            borderRadius: "50px",
            zIndex: 1200,
            backgroundColor: timeLeft < 60 ? "#d32f2f" : "teal",
            color: "white",
            transition: "background-color 0.5s ease",
          }}
        >
          <AccessTimeIcon fontSize="large" sx={{ mr: 1.5 }} />
          <Typography variant="h5" component="span" sx={{ fontWeight: "bold" }}>
            {displayTime}
          </Typography>
        </Paper>
      )}

      {showScore ? (
        <Card
          sx={{
            backgroundColor: isPassed ? "#e8f5e9" : "#ffebee",
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: isPassed ? "success.main" : "error.main",
            borderRadius: 4,
          }}
        >
          <CardContent sx={{ textAlign: "center", p: { xs: 3, sm: 5 } }}>
            <Box sx={{ ...popInAnimation }}>
              {isPassed ? (
                <CheckCircleOutlineIcon
                  sx={{
                    fontSize: { xs: 70, sm: 90 },
                    color: "success.main",
                    animation: "popIn 0.6s ease-out",
                  }}
                />
              ) : (
                <HighlightOffIcon
                  sx={{
                    fontSize: { xs: 70, sm: 90 },
                    color: "error.main",
                    animation: "popIn 0.6s ease-out",
                  }}
                />
              )}
            </Box>
            <Typography
              variant="h3"
              component="h2"
              gutterBottom
              sx={{
                mt: 2,
                fontWeight: "700",
                animation: "popIn 0.7s ease-out",
              }}
            >
              {isPassed ? "¡Felicidades, has aprobado!" : "¡Sigue intentando!"}
            </Typography>
            <Typography variant="h5" sx={{ mb: 3 }}>
              {isPassed
                ? "Un excelente resultado. ¡Buen trabajo!"
                : "No te rindas. Cada intento es un paso más cerca."}
            </Typography>
            <Typography variant="h4" sx={{ mb: 4, fontWeight: "500" }}>
              Tu puntuación:{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: isPassed ? "success.dark" : "error.dark",
                }}
              >
                {score}
              </Box>{" "}
              de {shuffledQuestions.length}
            </Typography>
            {/* CAMBIO AQUÍ: Color de fondo azul para el botón */}
            {isPassed ? <Button
              variant="contained"
              size="large"
              onClick={handleRestartQuiz}
              sx={{
                mt: 1,
                backgroundColor: "#1976d2", // Color azul primario de MUI
                "&:hover": {
                  backgroundColor: "#1565c0", // Un azul un poco más oscuro para el hover
                },
              }}
            >
              Seleccionar otro examen
            </Button>:   <Button
              variant="contained"
              size="large"
              onClick={handleRestartQuiz}
              sx={{
                mt: 1,
                backgroundColor: "#1976d2", // Color azul primario de MUI
                "&:hover": {
                  backgroundColor: "#1565c0", // Un azul un poco más oscuro para el hover
                },
              }}
            >
              Intentar de Nuevo
            </Button>}
          
          </CardContent>
        </Card>
      ) : (
        <>
          <Card sx={{ borderRadius: 4 }}>
            <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
              <Typography
                variant="h4"
                sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}
              >
                {selectedSavedExam.titulo_examen}
              </Typography>
              {shuffledQuestions.map((question, index) => (
                <React.Fragment key={index}>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                      {`${index + 1}. ${question.enunciado_pregunta}`}
                    </Typography>
                    <FormControl component="fieldset" fullWidth>
                      <FormLabel component="legend">
                        Elige una respuesta
                      </FormLabel>
                      <RadioGroup
                        aria-label={`question-${index}`}
                        name={`question-${index}`}
                        value={answers[index] || ""}
                        onChange={(e) =>
                          handleAnswerChange(index, e.target.value)
                        }
                      >
                        {question.answerOptions.map((answerOption) => (
                          <FormControlLabel
                            key={answerOption.texto_respuesta}
                            value={answerOption.texto_respuesta}
                            control={<Radio />}
                            label={answerOption.texto_respuesta}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  {index < shuffledQuestions.length - 1 && (
                    <Divider sx={{ my: 3 }} />
                  )}
                </React.Fragment>
              ))}
            </CardContent>
          </Card>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 8 }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleSubmit}
              disabled={!allQuestionsAnswered}
              sx={{
                backgroundColor: "teal",
                fontSize: "1.1rem",
                padding: "12px 32px",
                "&:hover": {
                  backgroundColor: "#006666",
                },
              }}
            >
              Finalizar Cuestionario
            </Button>
          </Box>
        </>
      )}
    </Container>
  );
}

export default QuizForm;
